import { render, staticRenderFns } from "./SelectMaterial.vue?vue&type=template&id=4afc4ba8&scoped=true&"
import script from "./SelectMaterial.vue?vue&type=script&lang=js&"
export * from "./SelectMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SelectMaterial.vue?vue&type=style&index=0&id=4afc4ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc4ba8",
  null
  
)

export default component.exports